import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import i18n from "../../config/languageInit";

class AdminService {
  changeLanguage(userId, languageCode) {
    return axios.post(
      `${API_GATEWAY + PR_DEP}/admin/change-language/${userId}/${languageCode}`
    );
  }
  getLanguage(mailAddress) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/admin/get-language/${mailAddress}`)
      .then((response) => {
        i18n.changeLanguage(response.data);
        axios.defaults.headers.common["Accept-Language"] = response.data;
      });
  }
}

export default new AdminService();
